import { BASE_PLAYER_HEIGHT, BASE_PLAYER_WIDTH } from '../paths/games/zones/status/PlayerStatus';
import { BASE_HEIGHT, BASE_WIDTH, BASE_WINDOW_HEIGHT, BASE_WINDOW_WIDTH } from '../paths/games/cardComponent';
import useWindowDimensions from './windowUtils';
import { BUTTON_HEIGHT, BUTTON_WIDTH } from '../paths/games/zones/status/UIButton';

export function useCardScale() {
    const { width, height } = useWindowDimensions();

    const horizontalScale = width / BASE_WINDOW_WIDTH;
    const verticalScale = height / BASE_WINDOW_HEIGHT;

    return Math.min(horizontalScale, verticalScale);
}

export default function useCardDimensions(scaleModifier: number = 1) {
    const baseScale = useCardScale();
    const modifiedScale = baseScale * scaleModifier;

    return { cardWidth: BASE_WIDTH * modifiedScale, cardHeight: BASE_HEIGHT * modifiedScale };
}

export function usePlayerCardDimensions(scaleModifier: number = 1) {
    const baseScale = useCardScale();
    const modifiedScale = baseScale * scaleModifier;

    return { cardWidth: BASE_PLAYER_WIDTH * modifiedScale, cardHeight: BASE_PLAYER_HEIGHT * modifiedScale };
}

export function useUIButtonDimensions(scaleModifier: number = 1) {
    const baseScale = useCardScale();
    const modifiedScale = baseScale * scaleModifier;

    return { buttonWidth: BUTTON_WIDTH * modifiedScale, buttonHeight: BUTTON_HEIGHT * modifiedScale };
}

export function useCardCornerOffset(scaleModifier: number = 1) {
    const { cardWidth, cardHeight } = useCardDimensions(scaleModifier);

    return {
        horizontalCornerOffset: (BASE_WIDTH - cardWidth) / 2,
        verticalCornerOffset: (BASE_HEIGHT - cardHeight) / 2
    }
}

export function useCardCenterOffset() {
    return { horizontalCenterOffset: BASE_WIDTH / 2, verticalCenterOffset: BASE_HEIGHT / 2 }
}